import styled from "styled-components";
import media from "styled-media-query";
import customMedia from "../../config/breakpoints";

export const CardContainer = styled.div`
  background: ${({ theme }) => theme.colors.grey50};
  border-bottom-right-radius: 4px;
  border-left: 2px solid ${({ theme }) => theme.colors.grey200};
  border-top-right-radius: 4px;
  box-sizing: border-box;
  padding: 32px 24px;
  width: 100%;
`;

export const TextContainer = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

export const IconContainer = styled.div`
  height: 24px;
  margin-right: 8px;
`;

export const HideOnMobile = styled.div`
  ${media.lessThan("small")`
    display:none;
  `}
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.blue};
  cursor: pointer;
  font-family: Aileron;
  text-decoration: underline;
`;

export const ContactContainer = styled.div`
  font-family: Aileron;
  font-size: 24px;
  font-weight: 700;
  margin-left: 30px;

  ${customMedia.lessThan("mobile")`
    background: ${({ theme }) => theme.colors.white};
    border: 2px solid ${({ theme }) => theme.colors.grey200};
    border-radius: 3px;
    color: ${({ theme }) => theme.colors.black};
    cursor: pointer;
    display:flex;
    align-items:center;
    justify-content:center;
    font-weight: 700;
    padding: 14px 8px;
    text-decoration: none;
    font-size: 18px;
    margin-left: 0px;
  `};
`;
